import React from 'react';
import {Card} from '../../../../_metronic/_partials/controls';
import {AgentsIncomesFilter} from '../components/agents-incomes-filter/AgentsIncomesFilter';
import {AgentsIncomesTable} from '../components/agents-incomes-table/AgentsIncomesTable';
import {AgentsIncomesFooter} from '../components/agents-incomes-footer/AgentsIncomesFooter';
import FooterBar from '../../_common/components/FooterBar';

export function AgentsIncomesCard() {
  return (
    <Card className={'flex-fill bg-transparent shadow-none'} id={'invoices-list-card'}>
      <AgentsIncomesFilter/>
      <AgentsIncomesTable/>
      <FooterBar>
        <AgentsIncomesFooter/>
      </FooterBar>
    </Card>
  );
}
